var Sidebar = React.createClass({
  getInitialState: function() {
    ios.on('a', data => {
      switch (data.id) {
        case 'room': {
          this.setState({
            inRoom: data.room !== false ? true : false
          })
          break
        }
        case 'rooms': {
          this.setState({
            rooms: window.rooms,
          })
          break
        }
      }
    })
    return {
      inRoom: false,
      rooms: [],
      o: mobileOrientation,
    }
  },
  componentDidMount: function() {
    window.mobileOrientationCallbacks.push(data => {
      this.setState({
        o: data
      })
    })
  },
  render: function() {
    return (
      <div className="sidebar">
				<div className="user-container">
					<User />
				</div>

				{isMobile ? null : <hr />}

				<div className="messages-container">
					<Messages />
				</div>

				<div className="room-container">
					<Room />
				</div>

				<div className="player-container">
					<Player />
				</div>

				<SidebarNotifications />
				{this.state.inRoom ? <GuestMessage /> : null}
				<CallList />

				<TabArea id="sidebar" className="no-guest">
					<Tab id="room" title={this.state.inRoom ? 'ROOM' : 'LOBBY'}>
						<div className="chat-container">
							<Chat />
						</div>
					</Tab>

					<Tab
      id="lobby"
      title={isMobile ? 'ROOMS' : 'LOBBY'}
      style={{
        display: this.state.inRoom || (isMobile && this.state.o == 'portrait') ? 'block' : 'none',
      }}
      >
						<div className="rooms-container">
							<Rooms items={this.state.rooms} />
						</div>
					</Tab>

					<Tab id="private" title="PRIVATE">
						<div className="chat-private-container">
							<ChatPrivate />
						</div>
					</Tab>

					<Tab id="friends" title="FRIENDS">
						<TabArea id="friends" inner="true">
							<Tab id="online" title="ONLINE">
								<div className="friend-list-container">
									<FriendList />
								</div>
							</Tab>
							<Tab id="requests" title="REQUESTS">
								<div className="friend-requests-container">
									<FriendRequests data={window.user.followers} />
								</div>
							</Tab>
						</TabArea>
					</Tab>
				</TabArea>
			</div>
    )
  },
})

var SidebarNotifications = React.createClass({
  render: function() {
    return (
      <div>
				{isMobile ? null : (
        <div>
						{ /*<div className="wtf center" style={{ backgroundColor: 'blueviolet' }}>
							<small>
								<a> 
								<img style= {{width: 10}} src="https://mobcpop.com/img/icon/s/cake.gif#32"></img> 
								<b> </b>HAPPY BIRTHDAY <b> </b>
								<a href="https://mobcpop.com/index.html#u/Kev">
									<b>#u/Kev</b> 
								</a>
								<b> </b>
								<img style={{width: 10}} src="/img/verified.png" className="verified" title="verified xD" />
								<b> </b>
								<img style={{width: 10}} src="https://mobcpop.com/img/icon/s/cake.gif#32"></img></a>
							</small>
						</div>*/ }
						<div className="wtf center " style={{
          backgroundColor: 'red'
        }}>
							<small>
								<a href="https://mobcpop.com/index.html#p/Issues/0" className="white">
									<b>Flash Works, Follow THIS</b>
								</a>
							</small>
						</div>
					</div>
        )}
			</div>
    )
  },
})

var GuestMessage = React.createClass({
  render: function() {
    return (
      <div>
				{isMobile ? null : (
        <div>
						<div className="wtf center guest-only" style={{
          backgroundColor: 'red'
        }}>
							<small>
								<b>Guests Need To Register To Chat</b>
							</small>
						</div>
					</div>
        )}
			</div>
    )
  },
})

$(function() {
  ReactDOM.render(<Sidebar />, document.querySelector('.sidebar-container'))
})